/**
 * 支持的 UI 语言与相关静态配置（纯数据，勿写逻辑）。
 * 解析 / 兜底 / 加载逻辑见 src/utils/i18n.js。
 *
 * 新增语言时：
 * 1. 往 SUPPORTED_LOCALES 追加 UI 码
 * 2. 在 public/locales/ 下补目录与 JSON
 * 3. 若 UI 码与目录名不一致，补 LOCALE_FOLDER_MAP（如 jp → ja）
 */

/** 默认语言；非法 / 空 locale 一律回退到这里 */
export const DEFAULT_LOCALE = 'en'

/** 对外暴露、可写入 localStorage / ?locale= 的语言码 */
export const SUPPORTED_LOCALES = [
  'en',
  'jp',
  'de',
  'kr',
  'fr',
  'es',
  'pt',
  'it-ch',
  'tr',
  'ar',
  'tw',
  'ru',
  'nl',
  'pl',
  'sv'
]

/**
 * UI 语言码 → public/locales 实际文件夹名。
 * 未列出的码默认与文件夹同名（如 en、es、de）。
 */
export const LOCALE_FOLDER_MAP = {
  jp: 'ja',
  kr: 'ko',
  'it-ch': 'it',
  tw: 'zh-Hant-TW'
}
